// src/EditProfilePage.js

import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Card, Layout, Menu } from 'antd';
import {
  DashboardOutlined,
  EditOutlined,
  FileSearchOutlined,
} from '@ant-design/icons';
import { BrowserRouter as Router, Switch, Route, Link, useLocation  } from 'react-router-dom';

import { useNavigate } from 'react-router';
import Sidebar from '../../Side_Bar/Customer_Side_Bar';
import { loadUserData  } from "../../User_Data.js";
import axios from 'axios'; // Import axios library

const { Sider, Content } = Layout;

const EditProfilePage = () =>{
  const location = useLocation();
  const [userData, setUserData] = useState(loadUserData());
  const mainUrl = "https://chatbot-summary-deployment-dot-fartech-yvqj.et.r.appspot.com";

  const [formData, setFormData] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(true); // Loading state

  useEffect(() => {
    // Define an asynchronous function to fetch data
    const fetchData = async () => {
      try {
        const response = await fetch(`${mainUrl}/getCustomerWithUsername?username=${userData.username}`);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        // Update the form data state with the fetched data
        setFormData({
          companyName: data[0].name,
          ssmNo: data[0].ssm_no,
          businessAddress: data[0].address,
          businessDescription: data[0].business_description,
          industry: data[0].industry,
          adminEmail: data[0].admin_email,
          financeEmail: data[0].finance_email,
          notificationEmail: data[0].notification_email,
          adminName: data[0].admin_name,
          adminContact: data[0].admin_contact_number,
          websiteURL: data[0].website_url,
          facebookProfile: data[0].facebook_profile_url,
          instagramProfile: data[0].instagram_profile_url,
          username: data[0].username,
        });

        setLoading(false);
        // Process the data as needed
      } catch (error) {
        console.error('Error fetching table data:', error);
        setLoading(false);
        // Handle the error
      }
    };
  
    // Invoke the asynchronous function
    fetchData();
  }, []); // Include dependencies if needed
  

  const onFinish = async (values) => {
    console.log('Received values:', values);
    try {
      const updatedData = {
        username: values.username, // Make sure to include the customer ID in your form data
        name: values.companyName,
        ssmNo: values.ssmNo,
        address: values.businessAddress,
        businessDescription: values.businessDescription,
        industry: values.industry,
        adminEmail: values.adminEmail,
        financeEmail: values.financeEmail,
        notificationEmail: values.notificationEmail,
        adminName: values.adminName,
        adminContactNumber: values.adminContact,
        websiteURL: values.websiteURL,
        facebookProfileURL: values.facebookProfile,
        instagramProfileURL: values.instagramProfile,
      };
  
      // Make the API call
      // const response = await axios.put(`${mainUrl}/updateCustomer`, updatedData);
      axios.put(mainUrl + `/updateCustomer`, updatedData)
      .then(response => {
        console.log('Updated Company Cost:', response.data);
      })
      .catch(error => {
        console.error('Error updating company cost:', error.response ? error.response.data : error.message);
      });

      } catch (error) {
        console.error('Error updating customer:', error);
      }
    setEditMode(false);
  };

  const onEdit = () => {
    setEditMode((prevEditMode) => !prevEditMode);
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sidebar location={location} />
          <Layout>
            <div style={{ maxWidth: '2000px', margin: '20px', textAlign: 'center', fontFamily: 'Helvetica, Arial, sans-serif' }}>
              <Card title={<span style={{ fontSize: '20px' }}>Edit Profile</span>} style={{ maxWidth: '1200px' }}>
                <div style={{ padding: '20px' }}>
                <Form
                    name="edit-profile-form"
                    initialValues={formData}
                    onFinish={onFinish}
                    onValuesChange={(changedValues) => {
                    setFormData((prevData) => ({ ...prevData, ...changedValues }));
                    }}
                >
                    <Form.Item label="Company Name" name="companyName" rules={[{ required: true }]}>
                    <Input disabled />
                    </Form.Item>

                    <Form.Item label="SSM No" name="ssmNo" rules={[{ required: true }]}>
                    <Input disabled />
                    </Form.Item>

                    <Form.Item label="Business Address" name="businessAddress" rules={[{ required: true }]}>
                    <Input disabled={!editMode} />
                    </Form.Item>

                    <Form.Item label="Business Description" name="businessDescription" rules={[{ required: true }]}>
                    <Input.TextArea disabled={!editMode} />
                    </Form.Item>

                    <Form.Item label="Industry" name="industry" rules={[{ required: true }]}>
                    <Input disabled={!editMode} />
                    </Form.Item>

                    <Form.Item label="Admin Email" name="adminEmail" rules={[{ required: true, type: 'email' }]}>
                    <Input disabled={!editMode} />
                    </Form.Item>

                    <Form.Item label="Finance Email" name="financeEmail" rules={[{ required: true, type: 'email' }]}>
                    <Input disabled={!editMode} />
                    </Form.Item>

                    <Form.Item label="Notification Email" name="notificationEmail" rules={[{ required: true, type: 'email' }]}>
                    <Input disabled={!editMode} />
                    </Form.Item>

                    <Form.Item label="Admin Name" name="adminName" rules={[{ required: true }]}>
                    <Input disabled={!editMode} />
                    </Form.Item>

                    <Form.Item label="Admin Contact" name="adminContact" rules={[{ required: true }]}>
                    <Input disabled={!editMode} />
                    </Form.Item>

                    <Form.Item label="Website URL" name="websiteURL" rules={[{ required: true, type: 'url' }]}>
                    <Input disabled={!editMode} />
                    </Form.Item>

                    <Form.Item label="Facebook Profile" name="facebookProfile" rules={[{ type: 'url' }]}>
                    <Input disabled={!editMode} />
                    </Form.Item>

                    <Form.Item label="Instagram Profile" name="instagramProfile" rules={[{ type: 'url' }]}>
                    <Input disabled={!editMode} />
                    </Form.Item>

                    <Form.Item label="Username" name="username">
                    <Input disabled />
                    </Form.Item>

                    <Form.Item>
                    <Button type="primary" htmlType="submit" style={{ marginRight: '10px', backgroundColor: '#1890ff' }} hidden={!editMode}>
                        Save Changes
                    </Button>
                    <Button type="primary" onClick={onEdit} style={{ backgroundColor: editMode ? '#f5222d' : '#1890ff' }}>
                        {editMode ? 'Cancel' : 'Edit Profile'}
                    </Button>
                    </Form.Item>
                </Form>
                </div>
              </Card>
            </div>
          </Layout>
          </Layout>
          
  );
};

export default EditProfilePage;
